import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(theme => ({
  item: {
    background: "#fafaff",
    border: 'solid 1px #e1e1ff',
    borderRadius: 3,
    margin: 3
  }
}));

export default function ThreadCard(props) {
  const classes = useStyles();

  return (
    <ListItem button className={classes.item} onClick={props.onClick} >
      <ListItemText
        primary={
          <Typography variant="h4">{props.title}</Typography>
        }
        secondary={
          <div>
            <Typography variant="subtitle1">{props.description}</Typography>
            <br />
            <Typography align="right" variant="body2">作成者: {props.creator}</Typography>
            <Typography align="right" variant="body2">{props.date}</Typography>
          </div>
        }
      />
    </ListItem>
  );
}
